<template>
  <v-container fluid>
    <v-card :loading="loading" class="mx-auto my-12 pa-5">
      <h1 style="text-align: center">{{ getInnerCardDetail.project_name }}</h1>
      <project-description
        :languages="getLanguages"
        :budget="getInnerCardDetail.project_budget"
        :url="getInnerCardDetail.project_website"
      ></project-description>
      <project-client :clientList="getClientList"></project-client>
      <project-platform :platformList="getPlatformList"></project-platform>
      <project-role :roleList="getRoleList"></project-role>
      <project-skill :skillList="getSkillList"></project-skill>
      <project-team :userList="getUserList"></project-team>
      <project-image></project-image>
    </v-card>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import ProjectClient from "@/components/Projects/ProjectInnerCardsComp/ProjectClient";
import ProjectDescription from "@/components/Projects/ProjectInnerCardsComp/ProjectDescription";
import ProjectPlatform from "@/components/Projects/ProjectInnerCardsComp/ProjectPlatform";
import ProjectRole from "@/components/Projects/ProjectInnerCardsComp/ProjectRole";
import ProjectSkill from "@/components/Projects/ProjectInnerCardsComp/ProjectSkill";
import ProjectTeam from "@/components/Projects/ProjectInnerCardsComp/ProjectTeam";
import ProjectImage from "@/components/Projects/ProjectInnerCardsComp/ProjectImage";
export default {
  props: ["projectDetail"],
  name: "ProjectInnerCard",
  components: {
    "project-client": ProjectClient,
    "project-description": ProjectDescription,
    "project-image": ProjectImage,
    "project-platform": ProjectPlatform,
    "project-role": ProjectRole,
    "project-skill": ProjectSkill,
    "project-team": ProjectTeam,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      "getInnerCardDetail",
      "getPlatformList",
      "getLanguages",
      "getSkillList",
      "getRoleList",
      "getClientList",
      "getUserList",
    ]),
  },
  mounted() {
    this.loadContent();
  },

  methods: {
    ...mapActions(["FetchInnerCard", "showLoadingProcess", "closeLoading"]),

    async loadContent() {
      await this.showLoadingProcess();
      try {
        this.loading = true;
        const id = this.$route.query.project_id;
        await this.FetchInnerCard(id);
        this.loading = false;
        await this.closeLoading();
      } catch (err) {
        console.log(err);
        this.loading = false;
        await this.closeLoading();
      }
    },
  },
};
</script>
